import { Policy } from '../../../models/policy/Policy';
import { HomePolicy } from '../../../models/homePolicy/HomePolicy';
import { Mail, CreditCard, ArrowRight } from 'lucide-react';

interface IMakePaymentProps {
  policy: Policy | HomePolicy;
  onProceed: (paymentOption: "send-email" | "make-payment") => void;
}

const MakePayment = (props: IMakePaymentProps) => {

  return (
    <div className="w-full max-w-2xl mx-auto p-6">
      {/* Header */}
      <div className="mb-8 text-center">
        <h3 className="text-xl font-bold font-poppins text-gray-900 dark:text-darkBg-mainText mb-2">
          How will the payment be made?
        </h3>
        <p className="text-sm text-gray-600 dark:text-darkBg-subText">
          Choose how you&apos;d like to process this payment
        </p>
      </div>

      {/* Payment Options */}
      <div className="space-y-4">
        {/* Send Email Option */}
        <div
          className="group bg-white dark:bg-darkBg border border-gray-200 dark:border-darkBg-border rounded-xl p-6 hover:shadow-lg transition-all duration-200 cursor-pointer hover:border-primary-main dark:hover:border-primary-main"
          onClick={() => props.onProceed("send-email")}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-primary-surface dark:bg-gray-700 rounded-lg flex items-center justify-center group-hover:bg-primary-main/10 transition-colors">
                <Mail className="w-6 h-6 text-primary-main dark:text-primary-main" />
              </div>
              <div className="text-left">
                <h4 className="text-base font-semibold text-gray-900 dark:text-darkBg-mainText mb-1">
                  Send payment link to customer
                </h4>
                <p className="text-sm text-gray-600 dark:text-darkBg-subText">
                  Email a secure payment link directly to the customer
                </p>
              </div>
            </div>
            <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-primary-main transition-colors" />
          </div>
        </div>

        {/* Make Payment Option */}
        <div
          className="group bg-white dark:bg-darkBg border border-gray-200 dark:border-darkBg-border rounded-xl p-6 hover:shadow-lg transition-all duration-200 cursor-pointer hover:border-primary-main dark:hover:border-primary-main"
          onClick={() => props.onProceed("make-payment")}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-primary-surface dark:bg-gray-700 rounded-lg flex items-center justify-center group-hover:bg-primary-main/10 transition-colors">
                <CreditCard className="w-6 h-6 text-primary-main dark:text-primary-main" />
              </div>
              <div className="text-left">
                <h4 className="text-base font-semibold text-gray-900 dark:text-darkBg-mainText mb-1">
                  Enter payment details for customer
                </h4>
                <p className="text-sm text-gray-600 dark:text-darkBg-subText">
                  Process payment directly on behalf of the customer
                </p>
              </div>
            </div>
            <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-primary-main transition-colors" />
          </div>
        </div>
      </div>

      {/* Payment Amount Display */}
      {props.policy?.quote?.paymentPlan?.initialDeposit && (
        <div className="mt-6 p-4 bg-gray-50 dark:bg-darkBg border border-gray-200 dark:border-darkBg-border rounded-lg">
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-gray-600 dark:text-darkBg-subText">
              Amount to be paid:
            </span>
            <span className="text-lg font-bold text-gray-900 dark:text-darkBg-mainText">
              GHS {props.policy.quote.paymentPlan.initialDeposit.toFixed(2)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MakePayment;

type paymentOptionTabs = "hubtel" | "itConsort"
